import script from "./ActionButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionButton.vue?vue&type=script&setup=true&lang=ts"

import "./ActionButton.vue?vue&type=style&index=0&id=e004cf5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e004cf5e"]])

export default __exports__